import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, PropType, ref, watch } from 'vue'
import { Tab, Tabs, DropdownMenu, DropdownItem } from 'vant'
import { useThemeColor } from '@/utils/theme'
import { isFeishu } from '@/utils/feishu'
import { isWechat } from '@/utils/weixin'
import { isApp } from '@/utils/client'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkNativeApp } from '@/utils/sandsTalkNative'
import { isSandsTalkSEAsiaOutfieldApp } from '@/utils/sandsTalkSEAsiaOutfield'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'

type TabDateOption = {
  title: string
  name: number | string
  badge?: number
}

type StatusOption = {
  text: string
  value: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TabBar',
  props: {
  tabDate: {
    type: Array as PropType<TabDateOption[]>
  },
  statusDate: {
    type: Array as PropType<StatusOption[]>
  },
  activeDate: {
    type: Number
  },
  isTranslation: {
    type: Boolean,
    default: true
  },
  isShrink: {
    // 是否开启收缩模式
    type: Boolean,
    default: false
  },
  tabsClass: {
    // 添加class名字
    type: String,
    default: ''
  },
  isThemeColor: {
    type: Boolean,
    default: true
  },
  defaultStatusIndex: {
    // 改变下拉框的默认值
    type: Number,
    default: 0
  },
  border: {
    type: Boolean,
    default: false
  }
},
  emits: ['upTab', 'upStatus'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "a21139da": (_unref(themeColor))
}))

const props = __props

const defaultIndex = ref<number>(props.defaultStatusIndex)
const activeName = ref(props.activeDate || 0)
const themeColor = props.isThemeColor ? useThemeColor() : 'white'
const emit = __emit

const onChange = (name: string) => {
  emit('upTab', name)
}

const changeStatus = async (value: number) => {
  defaultIndex.value = value
  emit('upStatus', defaultIndex.value)
}

watch(
  () => props.activeDate,
  (newData) => {
    activeName.value = newData as number
  }
)

watch(
  () => props.defaultStatusIndex,
  (newValue) => {
    defaultIndex.value = newValue
  }
)
onMounted(() => {
  if (props.statusDate && props.statusDate.length > 0) {
    props.statusDate.forEach((e, index) => {
      if (index === defaultIndex.value) {
        // defaultName.value = e.title
        emit('upStatus', defaultIndex.value)
      }
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['tabs_bar', props.tabsClass])
  }, [
    _createVNode(_unref(Tabs), {
      active: activeName.value,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      onChange: onChange,
      color: _unref(themeColor),
      ellipsis: false,
      shrink: __props.isShrink,
      border: __props.border
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabDate, (item, index) => {
          return (_openBlock(), _createBlock(_unref(Tab), {
            key: index,
            title: __props.isTranslation ? _ctx.$t(item.title) : item.title,
            name: item.name,
            badge: item.badge
          }, null, 8, ["title", "name", "badge"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active", "color", "shrink", "border"]),
    (props.statusDate)
      ? (_openBlock(), _createBlock(_unref(DropdownMenu), {
          key: 0,
          "active-color": "themeColor",
          class: _normalizeClass(
        _unref(isFeishu) || _unref(isWechat) || _unref(isApp) || _unref(isSandsTalkFlutterApp) || _unref(isSandsTalkNativeApp) || _unref(isSandsTalkSEAsiaOutfieldApp) || _unref(isSandsTalkPhOutfieldApp) || _unref(isSandsTalkMSFlutterApp)
          ? 'custom-dropdown-menu-other'
          : 'custom-dropdown-menu'
      )
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DropdownItem), {
              modelValue: defaultIndex.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((defaultIndex).value = $event)),
              options: props.statusDate,
              onChange: changeStatus
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})